import styled from 'styled-components';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

const ModalBody = styled.div`
    flex: 1;
    overflow: auto;
    padding: 18px;
    width: 100%;
    ${media.mdmin`
        padding: 20px;
    `}
`;

export default ModalBody;
